export interface RequestParams {
  [name: string]: string | boolean | undefined | number;
}

export interface ApiBaseParams {
  url?: string;
  data?: RequestParams;
}

export enum Method {
  GET = 'GET',
  PATCH = 'PATCH',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
}
